/**
 * Returns a numeric sort score representing how closely `label` matches `query`.
 * Lower = stronger match:
 *   0           – exact match (case-insensitive)
 *   1           – label starts with query
 *   2 + idx     – label contains query at character position idx
 *   Infinity    – no match
 */
export function matchScore(label: string, query: string): number {
  if (!query) {
    return 0;
  }
  const lowerLabel = label.toLowerCase();
  const lowerQuery = query.toLowerCase();
  if (lowerLabel === lowerQuery) {
    return 0;
  }
  if (lowerLabel.startsWith(lowerQuery)) {
    return 1;
  }
  const idx = lowerLabel.indexOf(lowerQuery);
  return idx === -1 ? Infinity : 2 + idx;
}
